import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BUYER_CARD_BASE_URL, REACT_APP_API_MY_INSTITUTION_URL } from '../config/settings/environment'

/**
 * Get basic buyer information.
 */
export const getBasicBuyerInformation = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BUYER_CARD_BASE_URL}/ficha/informacion_institucion?rut=${dni}`)
})

/**
 * Gets the dependent buyer data.
 */
export const getDependentBuyer = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BUYER_CARD_BASE_URL}/ficha/organismo_dependiente?rut=${dni}`)
})

/**
 * Gets the Institutional Management data.
 */
export const getInstitutionalManagement = factoryService(({ dni }) => {
  return getJsonRequest(`${REACT_APP_API_BUYER_CARD_BASE_URL}/ficha/informacion_representantes?rut=${dni}`)
})

/**
 * Gets encrypt Purchase Order
 */
export const getEncryptOrderNumber = factoryService(({ orderNumber }) => {
  return getJsonRequest(`${REACT_APP_API_MY_INSTITUTION_URL}/v1/mi-institucion/encrypt/orden-compra/${orderNumber}`)
})

/**
 * Gets encrypt Claim
 */
export const getEncryptClaim = factoryService(({ claimId }) => {
  return getJsonRequest(`${REACT_APP_API_MY_INSTITUTION_URL}/v1/mi-institucion/encrypt/reclamo/${claimId}`)
})
